<template>
  <div :class="[$style.notification, open ? $style.open : null, $style[type]]">
    <div :class="$style.content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default',
    },
  },
}
</script>

<style lang="scss" module>
.notification {
  position: fixed;
  top: 7rem;
  left: 0;
  z-index: 9999;

  max-width: 30rem;

  overflow: hidden;

  background-color: var(--white);

  box-shadow: 4px 4px 19px 0px rgba(0, 0, 0, 0.33);

  transform: translateX(-100%);

  transition: 0.3s translate ease-in;

  &:before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1.2rem;

    width: 4.5rem;

    transform: skewX(-40deg);

    content: '';
  }
}

.warning {
  &:before {
    background-color: var(--warning);
  }
}

.info {
  &:before {
    background-color: var(--info);
  }
}

.error {
  &:before {
    background-color: var(--error);
  }
}

.success {
  &:before {
    background-color: var(--success);
  }
}

.open {
  transform: translateX(0);
}

.content {
  padding: 2rem 4rem 2rem 6rem;

  word-break: break-all;
}
</style>
